<template lang="pug">
.c-progress-form__element
  label.c-progress-form__title
    | {{$t(`profiles.questions.${name}`)}}
  .c-multiple-choice
    .row.c-multiple-choice__options
      .column.c-multiple-choice__item.c-multiple-choice__item--auto
        input.c-multiple-choice__radio(type="radio" :value="true" :name="name" :id="yes" v-model="subQuestionValue")
        label.c-multiple-choice__label(:for="yes")
          | Oui
      .column.c-multiple-choice__item.c-multiple-choice__item--auto
        input.c-multiple-choice__radio(type="radio" :value="false" :name="name" :id="no" v-model="subQuestionValue")
        label.c-multiple-choice__label(:for="no")
          | Non
</template>

<script>
export default {
  props: [
    'name'
  ],
  computed: {
    subQuestionValue: {
      get () {
        return this.$store.state.person[this.name]
      },
      set (value) {
        this.$store.commit('updatePersonInfo', {name: this.name, value: value})
      }
    },
    yes () {
      return `${this.name}_yes`
    },
    no () {
      return `${this.name}_no`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/profiles/HouseSubQuestions.vue